import { render, staticRenderFns } from "./StripePay.vue?vue&type=template&id=1bf0ae26&scoped=true"
import script from "./StripePay.vue?vue&type=script&lang=ts"
export * from "./StripePay.vue?vue&type=script&lang=ts"
import style0 from "./StripePay.vue?vue&type=style&index=0&id=1bf0ae26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf0ae26",
  null
  
)

export default component.exports